<script>
  import { hooksStore } from "../../stores/hooks.store";
  import { onMount } from "svelte";
  import Icon from "../../components/Icon/Icon.svelte";
  import "./sidebarLeft.func";

  let menuComponents = hooksStore.applyFilters("sidebarMenuComponents", []);
  let menuComponentsTop = hooksStore.applyFilters("sidebarMenuTop", []);
  let menuComponentsBottom = hooksStore.applyFilters("sidebarMenuBottom", []);
</script>

<aside class="sidebar">
  <div class="sidebar__logo">
    <img src="assets/img/logo/logo.svg" alt="SmartApp" title="SmartApp" />
  </div>
  <nav class="sidebar__nav js-tab-nav">
    <ul>
      {#each menuComponentsTop as menu}
        <li>
          <span
            class="sidebar__nav-link"
            on:click|preventDefault={menu.callback}
          >
            <Icon kod={menu.icon} />
            <p>{menu.nazov}</p>
          </span>
        </li>
      {/each}
    </ul>
    <ul>
      {#each menuComponentsBottom as menu}
        <li>
          <span
            class="sidebar__nav-link"
            on:click|preventDefault={menu.callback}
          >
            <Icon kod={menu.icon} />
            <p>{menu.nazov}</p>
          </span>
        </li>
      {/each}
    </ul>
  </nav>
  {#each menuComponents as componentPromise}
    {#await componentPromise() then component}
      <svelte:component this={component.default} />
    {/await}
  {/each}
</aside>

<style>
  .sidebar__nav > ul > li {
    cursor: pointer;
  }
</style>
